import request from './request'

// 1. 企业认证输入
export const getCertification = (data) =>
  request({ url: '/api/login/business/verify/submit', method: 'post', data })